import { render, staticRenderFns } from "./Imprimir.vue?vue&type=template&id=3ffe8fcc&"
import script from "./Imprimir.vue?vue&type=script&lang=js&"
export * from "./Imprimir.vue?vue&type=script&lang=js&"
import style0 from "./Imprimir.vue?vue&type=style&index=0&id=3ffe8fcc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports